import Command from "@ckeditor/ckeditor5-core/src/command"

export default class InsertTableOfContentsBox extends Command {
  execute() {
    this.editor.model.change((writer) => {
      this.editor.model.insertContent(this.createTableOfContentsBox(writer))
    })
  }

  refresh() {
    const model = this.editor.model
    const selection = model.document.selection
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "tableOfContentsBox"
    )

    this.isEnabled = allowedIn !== null
  }

  createTableOfContentsBox(writer) {
    const box = writer.createElement("tableOfContentsBox")
    const title = writer.createElement("tableOfContentsBoxTitle", {
      id: this.anchorId(),
    })
    writer.append(title, box)
    return box
  }

  // 出来るだけ一意になるようにUNIXタイムスタンプを取ってくる
  anchorId() {
    return "anchor-" + String(new Date().getTime())
  }
}
